import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from "react-i18next";
import { app, dialog, DialogSize, UrlDialogInfo } from "@microsoft/teams-js";
import './templates.scss';
import { getAllTemplatesList, getTemplateColorsList } from '../../actions';
import Overflow from '../OverFlow/templateOverflow';
import { TFunction } from "i18next";
import NewTemplate from '../NewTemplate/newTemplate';
import { Spinner, Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell, Text } from '@fluentui/react-components';

export interface IListItem {
    header: string,
    media: JSX.Element,
}

export interface ITaskInfo {
    title?: string;
    height?: number;
    width?: number;
    url?: string;
    card?: string;
    fallbackUrl?: string;
    completionBotId?: string;
}

export interface ITemplate {
    id: string;
    templateName: string;
    authorGroups: string[];
    isIncidentSummary: boolean;
    creatorId: string;
    creatorName: string;
    isDynamic: boolean;
}

export interface ITemplateColor {
    id: string;
    backgroundColorId: string;
    backgroundColorUrl: string;
}

export interface ITemplateProps extends WithTranslation {
    templatesList: ITemplate[];
    templateColorsList: ITemplateColor[];
    getAllTemplatesList?: any;
    getTemplateColorsList?: any;
}

export interface ITemplateState {
    templates: ITemplate[];
    loader: boolean;
    selectTemplate?: any;
}

class Templates extends React.Component<ITemplateProps, ITemplateState> {
    readonly localize: TFunction;
    private interval: any;
    private isOpenTaskModuleAllowed: boolean;
    constructor(props: ITemplateProps) {
        super(props);
        this.localize = this.props.t;
        this.isOpenTaskModuleAllowed = true;
        this.state = {
            templates: this.props.templatesList,
            loader: true,
        };
        this.escFunction = this.escFunction.bind(this);
    }

    public async componentDidMount() {
        await app.initialize();
        document.removeEventListener("keydown", this.escFunction, false);
        await this.props.getAllTemplatesList();
        await this.props.getTemplateColorsList();

    }

    public componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
        clearInterval(this.interval);
    }

    public componentWillReceiveProps(nextProps: any) {

        if (nextProps.templatesList !== this.state.templates) {
            var templatesList: ITemplate[] = [];

            nextProps.templatesList.forEach((t: ITemplate) => {

                const dynamicTemplate: any = {
                    id: t.id,
                    templateName: t.templateName,
                    authorGroups: t.authorGroups,
                    isIncidentSummary: t.isIncidentSummary,
                    creatorId: t.creatorId,
                    creatorName: t.creatorName,
                    isDynamic: t.isDynamic,
                }
                templatesList.push(dynamicTemplate)
            })

            this.setState({
                templates: templatesList,
                loader: false
            })
        }
    }

    public render(): JSX.Element {
        if (this.state.loader) {
            return (
                <Spinner />
            );
        } else if (this.state.selectTemplate) {
            return (
                <div>
                    <NewTemplate selectTemplate={this.state.selectTemplate} onBackToList={this.onBackToList}></NewTemplate>
                </div>
            );
        } else if (this.state.templates.length === 0) {
            return (<div className="results">{this.localize("EmptyTemplates")}</div>);
        } else {
            return (
                <div className="list templateContainer">
                    <Table arial-label="Default table">
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell key="templateName"><Text weight='bold' truncate={true} wrap={false}>{this.localize("TemplateNameText")}</Text></TableHeaderCell>
                                <TableHeaderCell key="createdBy"><Text weight='bold' truncate={true} wrap={false}>{this.localize("CreatedBy")}</Text></TableHeaderCell>
                                <TableHeaderCell key="groupOfAuthors"><Text weight='bold' truncate={true} wrap={false}>{this.localize("AuthorGroupsText")}</Text></TableHeaderCell>
                                <TableHeaderCell key="actions"></TableHeaderCell>

                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {this.state.templates.filter(template => template.id !== "999" && template.id !== "010").map((template) => (
                                <TableRow className="tableRow" key={template.id} onClick={(e: any) => this.onSelectTemplate(template)}>
                                    <TableCell>
                                        <Text truncate={true} wrap={false}>
                                            {template.templateName}
                                        </Text>
                                    </TableCell>
                                    <TableCell>
                                        <Text truncate={true} wrap={false}>
                                            {template.creatorName}
                                        </Text>
                                    </TableCell>
                                    <TableCell>
                                        <Text truncate={true} wrap={false}>
                                            {`${template.authorGroups.length} Author Group${template.authorGroups.length !== 1 ? "s" : ""}`}
                                        </Text>
                                    </TableCell>
                                    <TableCell>
                                        <Overflow onSelectTemplate={this.onSelectTemplate} template={template}></Overflow>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            );
        }
    }

    public onSelectTemplate = (template: any) => {
        this.setState({ selectTemplate: template })
    }

    public onBackToList = () => {
        this.setState({ selectTemplate: null })
    }

    private escFunction = (event: any) => {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            dialog.url.submit();
        }
    }

    public onOpenTaskModule = (event: any, url: string, title: string) => {
        if (this.isOpenTaskModuleAllowed) {
            this.isOpenTaskModuleAllowed = false;
            let taskInfo: UrlDialogInfo = {
                url: url,
                title: title,
                size: {
                    height: 660,
                    width: 1000
                } as DialogSize,
                fallbackUrl: url,
            }

            let submitHandler = (result: dialog.ISdkResponse) => {
                this.isOpenTaskModuleAllowed = true;
            };

            dialog.url.open(taskInfo, submitHandler);
        }
    }
}

const mapStateToProps = (state: any) => {
    return { templatesList: state.templatesList, templateColorsList: state.templateColorsList };
}

const templatesWithTranslation = withTranslation()(Templates);
export default connect(mapStateToProps, { getAllTemplatesList, getTemplateColorsList })(templatesWithTranslation);